import { fromJS } from 'immutable';
import { v4 as uuidv4 } from 'uuid'
import actionTypes from '../../actions/actionTypes'
import requestStatus from '../../constants/requestStatus'
import { FLYER_DATA_DEFAULT, GRID_IMAGE_DEFAULT, MOVIE_PERFORMANCE_DEFAULT } from '../../constants/state';
import { addItemToArray, deleteItemFromArray, returnStateIfNoAction } from '../helpers';
import { GRID_IMAGE, IMAGE, MOVIE, MOVIE_PERFORMANCES, TEXT, TITLE } from '../../constants/itemTypes';


const getInitState = weeks => {
    return fromJS({
        status: requestStatus.INITIALIZED,
        error: null,
        currentWeek: weeks[1].isoWeek,
        ... FLYER_DATA_DEFAULT
    })
}


const onGet = (state, action) =>  state.set('status', requestStatus.REQUEST_PENDING)
                                        .set('error', '')

const onGetSuccess = (state, action) => {
    const { flyer } = action.payload

    delete  flyer.status
    delete flyer.error

    return fromJS({
        status: requestStatus.REQUEST_SUCCESS,
        error: '',
        ... flyer
    })
}

const onUpdateSuccess = (state, action) => {
    const { flyer } = action.payload

    return fromJS({
        ... flyer
    })
}

const onSuccess = (state, action) => state.set('status', requestStatus.REQUEST_SUCCESS)
                                        .set('error', '')


const onError = (state, action) => state.set('status', requestStatus.REQUEST_ERROR)
                                        .setIn(['error'], action.payload.errorMessage)


const onReset = (state) => state.set('status', requestStatus.INITIALIZED)
                                .set('error', null)

const addFlyerStructureItem = (state, action) => {
    const { side, section, area, itemId, itemType, edited, pk } = action.payload

    let newState = state
    let newItemId 
    let newItemType


    if('grid' === area)  {
        if(state.getIn(['flyers', pk,'flyerStructure', side, section, area, 'order']).count() > 3) {
            return state
        }

        newItemId = uuidv4()
        newItemType = GRID_IMAGE

        const itemToAdd = fromJS({
            ... GRID_IMAGE_DEFAULT,
            id: newItemId,
            itemId: itemId,
            itemType: itemType
        })


        const stateWithItem = state.setIn(['flyers', pk, 'gridImages', 'items', newItemId], itemToAdd)
        newState = addItemToArray(stateWithItem, ['flyers', pk, 'gridImages', 'order'], newItemId)
    } else if(false === area && MOVIE === itemType) {
        newItemId = uuidv4()
        newItemType = MOVIE_PERFORMANCES

        const itemToAdd = fromJS({
            ... MOVIE_PERFORMANCE_DEFAULT,
            id: newItemId,
            movieId: itemId,
        })

        const stateWithItem = state.setIn(['flyers', pk, 'moviePerformances', 'items', newItemId], itemToAdd)
        newState = addItemToArray(stateWithItem, ['flyers', pk, 'moviePerformances', 'order'], newItemId)

    } else {
        newItemId = itemId
        newItemType = itemType
    }


    const newItem = fromJS({
        id: newItemId,
        type: newItemType
    })


    const keyArray = ['flyers', pk, 'flyerStructure', side, section]
    const stateSetEdited = newState.setIn([...keyArray, ...['edited']], edited)

    if(area) {
        keyArray.push(area)
    }

    const stateWithItem = stateSetEdited.setIn([...keyArray, ...[ 'items', newItemId]], newItem)

    keyArray.push('order')

    return addItemToArray(stateWithItem, keyArray, newItemId)
}

const deleteFlyerStructureItem = (state, action) => {
    const { side, section, area, itemId, movieId, itemType, pk } = action.payload
    const isMoviePerformance = MOVIE_PERFORMANCES === itemType
    const isGridImage = GRID_IMAGE === itemType

    let itemIdToDelete

    if(!itemId && movieId && isMoviePerformance && !area) {
        const performances =  state.getIn(['flyers', pk, 'moviePerformances', 'items'])
        const selectedItems = state.getIn(['flyers', pk, 'flyerStructure', side, section, 'order'])

        
        itemIdToDelete = selectedItems.find(id => {
            return performances.has(id) && movieId === performances.getIn([id, 'movieId'])
        })
    } else if(!itemId && movieId && isGridImage && area) {
        const gridImages = state.getIn(['flyers', pk, 'gridImages', 'items'])
        const selectedItems = state.getIn(['flyers', pk, 'flyerStructure', side, section, area, 'order'])

        itemIdToDelete = selectedItems.find(id => {
            const item = gridImages.has(id) ? gridImages.get(id) : false

            return item && MOVIE === item.get('itemType') && movieId === item.get('itemId')
        })
    } else if(!movieId && itemId) {
        itemIdToDelete = itemId
    }

    if(!itemIdToDelete)  {
        return state
    }

    // delete from structure
    const keyArray = ['flyers', pk, 'flyerStructure', side, section]
    const stateSetEdited = state.setIn([...keyArray, ...['edited']], true)
    
    
    if(area) {
        keyArray.push(area)
    }
    
    keyArray.push('order')
    
    const stateWithoutItemInOrder = deleteItemFromArray(stateSetEdited, keyArray, itemIdToDelete)
    const newKeyArray = keyArray.slice(0, 5)
    
    if(area) {
        newKeyArray.push(area)
    }
    
    const stateItems = stateWithoutItemInOrder.getIn([...keyArray]).toJS()
    let stateWithoutItemWithCheck
    
    //check if item is still in order array if it was more than once in the order array 
    if(!_.contains(stateItems, itemIdToDelete)) {
        stateWithoutItemWithCheck = stateWithoutItemInOrder.deleteIn([...newKeyArray, ...[ 'items', itemIdToDelete]])
    } else {
        stateWithoutItemWithCheck = stateWithoutItemInOrder
    }
    
    // delete item
    if(isMoviePerformance || isGridImage) {
        const dataKey = isMoviePerformance ? 'moviePerformances' : 'gridImages'
        const stateWithoutItem = stateWithoutItemWithCheck.deleteIn(['flyers', pk, dataKey, 'items', itemIdToDelete])

        return deleteItemFromArray(stateWithoutItem, ['flyers', pk, dataKey, 'order'], itemIdToDelete)
    }  else {

        return stateWithoutItemWithCheck
    }
}

const addNewFlyer = (state, action) => {
    const { item } = action.payload

    return state.setIn(['flyers', item.pk], item)
}

const addFlyerElement = (state, action) => {
    const { item, section } = action.payload
    const stateWithItem = state.setIn([section, 'items', item.id], item)

    return addItemToArray(stateWithItem, [section, 'order'], item.id)
}

const updateFlyerElement = (state, action) => {
    const { item, section, pk } = action.payload
    let keyArray = [section]

    if(section === 'moviePerformances' || section === "gridImages") {
        keyArray = ['flyers', pk, section]
    }

    return state.setIn([...keyArray, ...['items', item.id]], item)
}

const updateFlyerSettings = (state, action) => {
    const {payload, pk} = action.payload

    return state.setIn(['flyers', pk, "flyerSettings"], payload)
}

const updateFlyerOrder = (state, action) => { //TODO
    const { side, section, area, order, pk } = action.payload
    const keyArray = ['flyers', pk, 'flyerStructure', side, section]

    if(area) {
        keyArray.push(area)
    }
    
    return state.setIn([...keyArray, ...[ 'order']], fromJS(order))
}

const deleteFlyerElement = (state, action) => {
    const { itemId, section, pk } = action.payload
    let keyArray = [section]
    if(pk) {
        keyArray = ['flyers', pk, section]
    } 
    const stateWithoutItem = state.deleteIn([...keyArray, ...['items', itemId]])
    return deleteItemFromArray(stateWithoutItem, [...keyArray, ...['order']], itemId)
}

const deleteFlyerCustomItem = (state, action) => {
    let newState = state 
    const { id, type } = action.payload
    const idsToDelete = [id]
    const flyers = state.get('flyers').toJS()

    if(IMAGE === type) {
        Object.keys(flyers).map(flyerPk => {
            const flyer = flyers[flyerPk]
            const {gridImages} = flyer
            const gridItems = gridImages.items

            Object.keys(gridItems).map(gridId => {
                const item = gridItems[gridId]

                if(IMAGE === item.itemType && item.itemId === id) {
                    idsToDelete.push(gridId)

                    newState = deleteFlyerElement(newState, {
                        payload: {
                            itemId: gridId, 
                            section: 'gridImages',
                            pk: flyerPk
                        }
                    })
                }
            })
        })
    }
    
    Object.keys(flyers).map(flyerPk => {
        const flyer = flyers[flyerPk]
        const {flyerStructure} = flyer
        Object.keys(flyerStructure).map(side => {
            Object.keys(flyerStructure[side]).map(section => {
                if(flyerStructure[side][section].hasOwnProperty('order')) {
                    flyerStructure[side][section].order.map(itemId => {
                        if(idsToDelete.includes(itemId)) {
                            newState = deleteFlyerStructureItem(newState, {
                                payload: {
                                    side: side, 
                                    section: section, 
                                    area: false, 
                                    itemId: itemId,
                                    pk: flyerPk
                                }
                            })
                        }
                    })
    
                } else {
                    Object.keys(flyerStructure[side][section]).map(area => {
                        if('object' === typeof flyerStructure[side][section][area]) {
                            flyerStructure[side][section][area].order.map(itemId => {
                                if(idsToDelete.includes(itemId)) {
                                    newState = deleteFlyerStructureItem(newState, {
                                        payload: {
                                            side: side, 
                                            section: section, 
                                            area: area, 
                                            itemId: itemId,
                                            pk: flyerPk
                                        }
                                    })
                                }
                            })
                        }
                    })
                }
            })
        })    
    }) 

    return newState
}

const setCustomDateSettings = (state, action) => {
    const {pk, dateObj} = action.payload

    return state.setIn(['flyers', pk, 'dateSettings'], dateObj)
}

const updateTooHigh = (state, action) => {
    const { side, section, tooHigh, pk } = action.payload

    return state.setIn(['flyers', pk, 'flyerStructure', side, section, 'tooHigh'], tooHigh)
}

const flyerReducer = weeks => (state = getInitState(weeks), action) => {
    returnStateIfNoAction(action, state)

    switch(action.type){
        case actionTypes.PRINT_DATA_GET_REQUEST:
        case actionTypes.PRINT_DATA_FLYER_PDF_REQUEST:
            return onGet(state);
        case actionTypes.PRINT_DATA_GET_SUCCESS:
            return onGetSuccess(state, action).set('hasChanges', false);
        case actionTypes.PRINT_DATA_UPDATE_SUCCESS:
            return onUpdateSuccess(state, action).set('hasChanges', false);
        case actionTypes.PRINT_DATA_FLYER_PDF_SUCCESS:
            return onSuccess(state)
        case actionTypes.PRINT_DATA_GET_ERROR:
        case actionTypes.PRINT_DATA_FLYER_PDF_ERROR:
            return onError(state, action);
        case actionTypes.PRINT_DATA_FLYER_PDF_RESET:
            return onReset(state)

        case actionTypes.PRINT_LOCAL_DATA_FLYER_UPDATE_CURRENT_WEEK:
            return state.set('currentWeek', action.payload.week).set('hasChanges', true);
        case actionTypes.PRINT_LOCAL_DATA_FLYER_ADD_DATE_SETTINGS:
            return setCustomDateSettings(state, action).set('hasChanges', true);
        case actionTypes.PRINT_LOCAL_DATA_FLYER_ADD_FLYER_STRUCTURE_ITEM:
            return addFlyerStructureItem(state, action).set('hasChanges', true);
        case actionTypes.PRINT_LOCAL_DATA_FLYER_DELETE_FLYER_STRUCTURE_ITEM:
            return deleteFlyerStructureItem(state, action).set('hasChanges', true);
        case actionTypes.PRINT_LOCAL_DATA_FLYER_ADD_FLYER_ELEMENT:
            return addFlyerElement(state, action).set('hasChanges', true);
        case actionTypes.PRINT_LOCAL_DATA_FLYER_UPDATE_FLYER_ELEMENT:
            return updateFlyerElement(state, action).set('hasChanges', true);
        case actionTypes.PRINT_LOCAL_DATA_FLYER_ADD_NEW_FLYER:
            return addNewFlyer(state, action).set('hasChanges', true);
        case actionTypes.PRINT_LOCAL_DATA_FLYER_UPDATE_FLYER_SETTINGS:
            return updateFlyerSettings(state, action).set('hasChanges', true);
        case actionTypes.PRINT_LOCAL_DATA_FLYER_UPDATE_FLYER_ORDER:
            return updateFlyerOrder(state, action).set('hasChanges', true);
        case actionTypes.PRINT_LOCAL_DATA_FLYER_DELETE_FLYER_ELEMENT:
            return deleteFlyerElement(state, action).set('hasChanges', true);
        case actionTypes.PRINT_LOCAL_DATA_FLYER_DELETE_FLYER_CUSTOM_ELEMENT:
            return deleteFlyerCustomItem(state, action).set('hasChanges', true);
        case actionTypes.PRINT_DATA_FLYER_UPDATE_TOO_HIGH:
            return updateTooHigh(state, action).set('hasChanges', true);
        default:
            return state;
    }
}


export default flyerReducer;